import React from 'react';
import MultiScooterDashboard from './MultiScooterDashboard';

const RiderDashboard: React.FC = () => {
  console.log('🏠 RiderDashboard: Component rendering');
  return <MultiScooterDashboard />;
};

export default RiderDashboard;